import getStore from "../store/store";
import { mutatorAction } from "satcheljs";
import saveQuickStepsToService from "../util/saveQuickStepsToService";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import type { QuickStepTemplateType } from "owa-quick-step-types";

const TEMPLATE_ACTION_TYPES = ["replyWithTemplate", "replyAllWithTemplate", "forwardWithTemplate"];

/**
 * Removes any Quick Step actions that reference the given templateId.
 * If a Quick Step ends up with zero remaining actions, the entire Quick Step is removed.
 * Persists the updated config to OCS afterward.
 */
export const removeQuickStepsByTemplateIdMutator: (mailboxInfo: MailboxInfo, templateId: string) => void = mutatorAction("removeQuickStepsByTemplateId", (mailboxInfo: MailboxInfo, templateId: string): void => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const quickStepsConfig = getStore().quickStepsStoreMap.get(accountKey);
    let removedCount = 0;
    if (quickStepsConfig) {
        // Walk backwards so splicing doesn't shift indices
        for (let i = quickStepsConfig.quickSteps.length - 1; i >= 0; i--) {
            const quickStep = quickStepsConfig.quickSteps[i];
            // Filter out actions that reference the deleted template
            const filteredActions = quickStep.actions.filter(action => {
                if (TEMPLATE_ACTION_TYPES.includes(action.type ?? "")) {
                    const extra = action.extraInfo as QuickStepTemplateType | undefined;
                    return extra?.templateId !== templateId;
                }
                return true;
            });
            if (filteredActions.length === 0) {
                // No actions remain — remove the entire Quick Step
                quickStepsConfig.quickSteps.splice(i, 1);
                removedCount++;
            }
            else if (filteredActions.length < quickStep.actions.length) {
                // Some actions were removed but others remain — update in place
                quickStep.actions = filteredActions;
                removedCount++;
            }
        }
        if (removedCount > 0) {
            const configString = JSON.stringify(quickStepsConfig);
            saveQuickStepsToService(mailboxInfo, configString);
        }
    }
});
